import { Client, FishingGuide, FishingTrip, User } from './types';

export const COLORS = {
  primary: '#FF6B35', 
  primaryDark: '#E85A2C',
  secondary: '#4A4A4A', 
  background: '#F5F5F5',
  white: '#FFFFFF',
};

export const FISH_SPECIES = {
  common: ['Tucunaré', 'Tambaqui', 'Dourada', 'Caranha', 'Matrinchã', 'Cachara', 'Mandubé', 'Bicuda', 'Cachora', 'Barbado', 'Aruanã', 'Apapá'],
  large: ['Piraíba', 'Pirarara', 'Pirarucu']
};

export const BRAZIL_STATES = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
export const NATIONALITIES = ['Brasileira', 'Argentina', 'Uruguaia', 'Paraguaia', 'Chilena', 'Peruana', 'Boliviana', 'Equatoriana', 'Colombiana', 'Venezuelana', 'Norte-Americana', 'Outra'];
export const DIETARY_OPTIONS = ['Vegetariana', 'Vegana', 'Sem glúten', 'Sem lactose', 'Alergia a frutos do mar', 'Alergia a amendoim', 'Alergia a castanhas', 'Diabético', 'Hipertensão', 'Outra'];

export const RESERVATION_STATUS = {
  budget: { label: 'Orçamento (Rascunho)', color: 'bg-gray-100 text-gray-700 border-gray-200' },
  pre_reserved: { label: 'Pré-Reserva', color: 'bg-yellow-50 text-yellow-700 border-yellow-200' },
  confirmed: { label: 'Confirmada', color: 'bg-green-50 text-green-700 border-green-200' },
  completed: { label: 'Concluída', color: 'bg-blue-50 text-blue-700 border-blue-200' },
  cancelled: { label: 'Cancelada', color: 'bg-red-50 text-red-700 border-red-200' }
};

export const PACKAGE_OPTIONS = [2, 3, 4, 5, 6, 7];
export const STANDARD_SERVICES = [
  { id: 'kit_churrasco', label: 'Kit Churrasco Completo' },
  { id: 'kit_sashimi', label: 'Kit Sashimi' },
  { id: 'petiscos', label: 'Petiscos Variados' },
  { id: 'bebidas', label: 'Bebidas (Água/Refri/Cerveja)' },
  { id: 'iscas_vivas', label: 'Iscas Vivas' },
  { id: 'gelo', label: 'Gelo' },
  { id: 'carvao', label: 'Carvão' },
  { id: 'combustivel', label: 'Combustível (Gasolina)' },
  { id: 'guia_barco', label: 'Guia e Embarcação' },
  { id: 'starlink', label: 'Wi-Fi Starlink' },
];

export const EVENTS = [
  { title: 'Mulheres no Araguaia', description: 'O maior encontro de pesca feminina da região.', instagram: 'https://www.instagram.com/mulheresnoaraguaia', color: 'pink', icon: 'Flower' },
  { title: 'Torneio de Casais', description: 'Competição, parceria e muito amor no rio.', instagram: 'https://www.instagram.com/torneiodecasais.ar', color: 'red', icon: 'Heart' }
];

export const FINANCIAL_CATEGORIES = {
  'pescaria': 'Pacote de Pesca',
  'venda_loja': 'Venda Loja/Bebidas',
  'investimento': 'Aporte/Investimento',
  'salario': 'Salários',
  'aluguel': 'Aluguel',
  'energia': 'Energia Elétrica',
  'internet': 'Internet/Starlink',
  'contador': 'Contabilidade',
  'combustivel': 'Combustível',
  'manutencao_barco': 'Manutenção Barcos',
  'manutencao_pousada': 'Manutenção Pousada',
  'supermercado': 'Alimentação/Bebidas',
  'marketing': 'Marketing/Anúncios',
  'financiamento': 'Empréstimo/Financiamento',
  'imposto': 'Impostos',
  'taxa_banco': 'Taxas Bancárias',
  'outros': 'Outros'
};

export const PAYMENT_METHODS = ['Dinheiro', 'Pix', 'Cartão de Crédito', 'Cartão de Débito', 'Transferência Bancária'];

export const MOCK_USERS: User[] = [{ 
  uid: 'u1', 
  id: 'u1', 
  displayName: 'Aleffer Admin', 
  name: 'Aleffer Admin', 
  email: 'admin@nossapesca.com', 
  role: 'admin',
  createdAt: new Date(),
  lastLogin: new Date()
}];
export const MOCK_GUIDES: FishingGuide[] = [];
export const MOCK_CLIENTS: Client[] = [];
export const MOCK_TRIPS: FishingTrip[] = [];